import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { I18NextPipe } from 'angular-i18next';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [RouterOutlet],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {
  private title = inject(Title);
  private i18n = inject(I18NextPipe);

  constructor() {
    this.title.setTitle(this.i18n.transform('app.title'));
  }
}
